<style lang="stylus">
    .fileview-template-container
        display flex
        flex-direction column
        flex 1
        .template-item
            position relative
            width 198px
            height 172px
            border-radius 8px
            border 1px solid rgba(0,0,0,0.08)
            margin 0
            cursor pointer
            overflow hidden
            .template-imgbox
                position relative
                width 100%
                height 130px
                padding 8px
                img
                    width 182px
                    height 116px
                    object-fit contain
                    margin-bottom 8px
                    padding 0
                    border-radius 0
                .imgbox-mask
                    display none
                    position absolute
                    left 0
                    top 0
                    width 100%
                    height 100%
                    background rgba(0,0,0,0.4)
            .template-titlebox
                position absolute
                left 0
                bottom 0
                display flex
                align-items center
                width 100%
                height 40px
                padding 0 6px
                border-top 1px solid rgba(0,0,0,0.08)
                .file-text
                    color #222
                    font-size 14px
                    line-height 16px
                    overflow hidden
                    white-space: nowrap;
                    text-overflow: ellipsis;
            .menu-box
                display flex
                z-index 2
                position absolute
                top 8px
                right 8px
                .menu-right
                    display none
                    justify-content space-between
                    column-gap 4px
                    align-items center
                    .fileview-icon
                        width 24px
                        height 24px
                        border-radius 4px
                        background #fff
                        cursor pointer
                        svg
                            width 24px
                            height 24px
                            color #222
                        &:hover
                            svg
                                color #017fff
            &:hover
                border-color #017fff
                .template-imgbox
                    .imgbox-mask
                        display block
                .menu-box
                    .menu-right
                        display flex
            &.active
                border-color #017fff
        .template-listitem
            width: 100%;
            height: 56px;
            font-size: 14px;
            line-height 16px
            cursor: pointer;
            position: relative;
            user-select: none;
            display: flex;
            align-items: center;
            border-radius 6px
            margin-bottom 4px
            >div
                color rgba(0, 0, 0, 0.50)
                textOverflow()
            &:hover
                background rgba(242, 244, 249, 0.60)
            .file-name
                width 36%
                display flex
                align-items center
                padding-left 24px
                .file-icon
                    pointer-events auto
                    margin: 0;
                    width: 32px;
                    height: 32px;
                    flex-shrink 0
                    use
                        pointer-events none
                .file-text
                    margin-left 8px
                    font-size 14px
                    color #222
                    margin-right: auto;
                    overflow hidden
                    white-space: nowrap;
                    text-overflow: ellipsis;
            .file-time
                width 45.5%
            .file-empty
                width 18.5%
        .fileview-template-list-header
            .file-name
                width 36%
            .file-time
                width 45.5%
            .file-empty
                width 18.5%
</style>

<template>
    <div class="fileview-template-container" v-click-outside="closeContext" @click="closeContext">
        <Searchback v-if="searchMode" :str="lastSearch" :num="searchList.length" @searchBack="searchBack" />

        <div v-if="layoutMode == 'list' && !searchMode && !noDataStatus" class="fileview-list-header fileview-template-list-header">
            <div class="file-name" @click="clickOrder('name')">
                <span>{{ $t("name") }}</span>
                <div class="icon-con">
                    <iconSymbol
                        :class="{ 'active-icon': orderName == 'name' && rotate == 180 }"
                        style="transform: rotate(180deg)"
                        :name="'pcview-fileUpIcon'"
                    ></iconSymbol>
                    <iconSymbol :class="{ 'active-icon': orderName == 'name' && rotate == 0 }" :name="'pcview-fileUpIcon'"></iconSymbol>
                </div>
            </div>
            <div class="file-time" @click="clickOrder('time')">
                <span>{{ $t("time") }}</span>
                <div class="icon-con">
                    <iconSymbol
                        :class="{ 'active-icon': orderName == 'time' && rotate == 180 }"
                        style="transform: rotate(180deg)"
                        :name="'pcview-fileUpIcon'"
                    ></iconSymbol>
                    <iconSymbol :class="{ 'active-icon': orderName == 'time' && rotate == 0 }" :name="'pcview-fileUpIcon'"></iconSymbol>
                </div>
            </div>
            <div class="file-empty"></div>
        </div>

        <div class="fileview-scroll" ref="filesScroll" @scroll="closeContext()">
            <template v-if="layoutMode == 'grid'">
                <div class="files-box">
                    <div
                        class="template-item"
                        :class="{ active: index == customDelIndex }"
                        v-for="(item, index) in activeList"
                        @click="useCustomTemplate(item)"
                        @contextmenu="showCustomTContext($event, index)"
                    >
                        <div class="template-imgbox">
                            <img :src="item.img_url" alt="" />
                            <div class="imgbox-mask"></div>
                        </div>
                        <div class="template-titlebox">
                            <p class="file-text" v-if="searchFileName(item.name)">
                                <span v-for="str in searchFileName(item.name)" :class="{ 'search-text-highlight': str == searchValue }">
                                    {{ str }}
                                </span>
                            </p>
                            <span class="file-text" v-else>{{ item.name }}</span>
                        </div>
                        <div class="menu-box">
                            <div class="menu-right">
                                <div class="fileview-icon">
                                    <iconSymbol :name="'pcview-moreIcon'" @click.stop.native="showCustomTContext($event, index)" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <template v-if="layoutMode == 'list'">
                <div class="list-cons">
                    <div class="files-box-list" ref="filesBoxList">
                        <div
                            class="template-listitem"
                            v-for="(item, index) in activeList"
                            @click="useCustomTemplate(item)"
                            @contextmenu="showCustomTContext($event, index)"
                        >
                            <div class="file-name" :title="item.name">
                                <img class="file-icon" name="eddxFileIcon" src="@/home/assets/onlineview/file.svg" alt="" />
                                <p class="file-text" v-if="searchFileName(item.name)">
                                    <span v-for="str in searchFileName(item.name)" :class="{ 'search-text-highlight': str == searchValue }">
                                        {{ str }}
                                    </span>
                                </p>
                                <span class="file-text" v-else>{{ item.name }}</span>
                            </div>
                            <div class="file-time" :title="formatDate(item.created_at)">{{ formatDate(item.created_at) }}</div>
                            <div class="file-empty"></div>
                        </div>
                    </div>
                </div>
            </template>

            <div class="emptyCloud limit-position" v-show="emptyStatus">
                <img src="@/home/assets/img/null-icon/template-null.svg" alt="" />
                <p>
                    {{ $t("customNoData") }}
                    <span class="click-text" @click="toCloud" v-if="internal && !isWorkwx">{{ $t("customTocloud") }}</span>
                </p>
            </div>
            <div ref="scrollblock"></div>
        </div>
        <RightMenu
            v-if="menuContext.show && menuContext.type == 'customTemplate'"
            :style="{ left: `${menuContext.left}px`, top: `${menuContext.top}px` }"
            :menuList="[{ label: $t('deleteCustomT') }]"
            @handleClicks="deleteCustomTemplate()"
        />
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    import RightMenu from "../RightMenu.vue";
    import naturalsort from "javascript-natural-sort";
    naturalsort.insensitive = true;
    import Searchback from "./parts/searchback.vue";
    import { openNewTab } from "@/public/utils/tool";
    @Component({
        components: {
            RightMenu,
            Searchback,
        },
    })
    export default class Template extends Vue {
        //customTemplate-content
        customLoaded = false;
        customTPageInfo = {
            total: 0,
            count: 20,
            offset: 0,
            currentPage: 1,
        };
        customTList = [];
        customDelIndex = -1;
        useCustomTFlag = false;
        get emptyStatus() {
            return this.customLoaded && this.activeList.length == 0;
        }
        get noDataStatus() {
            return this.customTList.length == 0;
        }
        get showCustomPage() {
            return this.customTList.length > 0 && this.customTPageInfo.total > this.customTPageInfo.count;
        }
        get userInfo() {
            return this.$store.state.userInfo;
        }
        initCustomData() {
            if (!this.$validateLogin()) return;
            this.customLoaded = false;
            let user = {
                user_id: this.userInfo.user_id,
                token: this.userInfo.token,
                offset: (this.customTPageInfo.currentPage - 1) * this.customTPageInfo.count,
                count: this.customTPageInfo.count,
            };
            this.$edApi.getCustomTemplateList(user).then((e) => {
                this.customLoaded = true;
                this.customTList = e.data || [];
                this.customTPageInfo.total = e.msg - 0;
                console.log(this.customTList);
                this.addScroller();
            });
        }
        changeCustomTemplatePage(page) {
            if (!this.$validateLogin()) return;
            let user = {
                user_id: this.userInfo.user_id,
                token: this.userInfo.token,
                offset: (page - 1) * this.customTPageInfo.count,
                count: this.customTPageInfo.count,
            };
            this.$edApi.getCustomTemplateList(user).then((e) => {
                this.customTPageInfo.currentPage = page;
                this.customTList = this.customTList.concat(e.data);
                this.customTPageInfo.total = e.msg - 0;
                this.scrollAdding = false;
            });
        }

        initData() {
            if (this.searchMode) {
                this.search();
            } else {
                this.initCustomData();
            }
        }
        nextPage(page) {
            if (this.searchMode) {
                this.nextSearchPage(page);
            } else {
                this.changeCustomTemplatePage(page);
            }
        }
        resetPageInfo() {
            if (this.searchMode) {
                this.searchPageInfo = {
                    total: 0,
                    count: 20,
                    offset: 0,
                    currentPage: 1,
                };
            } else {
                this.customTPageInfo = {
                    total: 0,
                    count: 20,
                    offset: 0,
                    currentPage: 1,
                };
            }
        }
        lastSearch = "";
        searchValue = "";
        searchMode = false;
        searchList = [];
        searchPageInfo = {
            total: 0,
            count: 20,
            offset: 0,
            currentPage: 1,
        };
        get activeList() {
            return this.searchMode ? this.searchList : this.customTList;
        }
        get activePageInfo() {
            return this.searchMode ? this.searchPageInfo : this.customTPageInfo;
        }
        search() {
            this.resetPageInfo();
            if (this.searchValue) {
                this.lastSearch = this.searchValue;
                this.searchMode = true;
                this.searchList = [];
                this.$store.commit("setState", { data: true, type: "showLoading" });
                this.searchValue = this.searchValue.trim();

                this.customLoaded = false;
                let user = {
                    user_id: this.userInfo.user_id,
                    token: this.userInfo.token,
                    offset: (this.searchPageInfo.currentPage - 1) * this.searchPageInfo.count,
                    count: this.searchPageInfo.count,
                    search: this.searchValue,
                };
                this.$edApi.getCustomTemplateList(user).then((e) => {
                    this.customLoaded = true;
                    this.searchList = e.data || [];
                    this.searchPageInfo.total = e.msg - 0;
                    if (this.searchList.length == 0) {
                        (<any>this).$edMessage.error(this.$t("notFind"));
                    }
                    this.$store.commit("setState", { data: false, type: "showLoading" });
                });
            } else {
                this.searchMode = false;
            }
        }
        nextSearchPage(page) {
            if (!this.$validateLogin()) return;
            let user = {
                user_id: this.userInfo.user_id,
                token: this.userInfo.token,
                offset: (page - 1) * this.searchPageInfo.count,
                count: this.searchPageInfo.count,
            };
            this.$edApi.getCustomTemplateList(user).then((e) => {
                this.searchPageInfo.currentPage = page;
                this.searchList = this.searchList.concat(e.data);
                this.searchPageInfo.total = e.msg - 0;
                this.scrollAdding = false;
                this.addScroller();
            });
        }
        searchBack() {
            this.searchMode = false;
            this.searchValue = "";
            this.resetPageInfo();
            this.initData();
        }
        searchFileName(fileName) {
            if (this.searchValue) {
                return fileName
                    .replace(new RegExp(`${this.searchValue}`, "g"), `%%${this.searchValue}%%`)
                    .split("%%")
                    .filter((item) => item != "");
            }
            return "";
        }

        menuContext = {
            left: 0,
            top: 0,
            type: "",
            show: false,
        };
        showCustomTContext(e, index) {
            e.preventDefault();
            this.menuContext.type = "customTemplate";
            this.menuContext.show = true;
            this.menuContext.left = e.pageX;
            this.menuContext.top = e.pageY;
            if (document.documentElement.clientHeight - e.pageY < 200) {
                this.menuContext.top -= 44;
            }
            if (document.documentElement.clientWidth - e.pageX < 200) {
                this.menuContext.left -= 117;
            }
            this.customDelIndex = index;
        }
        closeContext() {
            this.menuContext.show = false;
            this.customDelIndex = -1;
        }
        useCustomTemplate(item) {
            if (!this.$validateLogin() || this.useCustomTFlag) return;
            let ts: any = this;
            this.useCustomTFlag = true;
            let user = {
                user_id: this.userInfo.user_id,
                token: this.userInfo.token,
                template_id: item.id,
                platform: this.$store.state.publicStore.runPlatform,
                tpl_file_key: item.tpl_file_key,
            };
            let newTab: any;
            let newTabCallback;
            let cancelOpen;
            if (!this.openInTabs) {
                // newTab = window.open(`${window.location.origin}${(<any>this.$router).options.base}app.html`, "");
                let task = openNewTab(`${window.location.origin}${(<any>this.$router).options.base}app.html`, this.$edMessage.destroy);
                newTabCallback = task.openTab;
                cancelOpen = task.cancelOpen;
                this.$edMessage.info(this.$tc("newPageCreateFile"), 0);
            }
            let limitCallback = (type = "") => {
                newTab && newTab.close();
                cancelOpen && cancelOpen();
                this.$edMessage.destroy();
                if (type == "showLimitModal") {
                    this.$bus.$on("limitModalContinue", () => {
                        console.log("on event");
                        this.$bus.$off("limitModalContinue");
                        this.useCustomTemplate(item);
                    });
                    this.$store.commit("setState", {
                        type: "showLimitFileModal",
                        data: true,
                    });
                } else if (type == "showLimitCloudSpaceVIP") {
                    if (this.fuser) {
                        this.$bus.$emit("showCloudSpaceVipTips");
                    } else {
                        this.$checkAuth({ type: "cloudSpaceVIP", buyTrigger: "cloudSpacePop" });
                    }
                } else if (type == "showLimitCloudSpace") {
                    this.$checkAuth({ type: "cloudSpace", buyTrigger: "cloudSpacePop" });
                } else {
                    this.$store.commit("toPublicStatus", {
                        type: "showUpgrade",
                        data: "fileNum",
                    });
                }
            };
            let enterCanvasTrack = `&file_source=templateFile&template_type=personalTemplate&diagram_type=others`;
            let trackSuffix = "";
            trackSuffix += enterCanvasTrack;
            this.$openFile({
                params: user,
                fileType: "customTemplate",
                suffix: trackSuffix,
                checkLimit: true,
                limitRange: this.$store.state.publicStore.runPlatform,
                limitCallback: limitCallback,
                vip: this.vip,
                isFullCouldSpace: this.isFullCouldSpace,
            })
                .then((obj) => {
                    this.sensors.track("generateCloudFile", {
                        Catalogues: "openFileProcess",
                        file_source: "templateFile",
                    });
                    if (this.openInTabs) {
                        location.href = obj.url;
                    } else {
                        this.$edMessage.destroy();
                        newTab = newTabCallback(obj.url);
                    }
                    this.useCustomTFlag = false;

                    // add open record
                    let key = obj.obj;
                    let openTabs = JSON.parse(localStorage.getItem("openTabs")) || [];
                    if (!openTabs.includes(key)) {
                        openTabs.push(key);
                    }
                    this.$store.commit("addWin", newTab);
                    localStorage.setItem("openTabs", JSON.stringify(openTabs));
                })
                .catch(() => {
                    this.useCustomTFlag = false;
                });
        }
        deleteCustomTemplate() {
            if (!this.$validateLogin()) return;
            let user = {
                user_id: this.userInfo.user_id,
                token: this.userInfo.token,
                template_ids: [this.activeList[this.customDelIndex].id],
            };
            if (this.isPrivate) {
                Object.assign(user, {
                    tpl_file_keys: [this.activeList[this.customDelIndex].tpl_file_key],
                });
            }
            this.$edApi.deleteCustomTemplate(user).then((e) => {
                this.customDelIndex = -1;
                this.closeContext();
                this.resetPageInfo();
                this.initData();
            });
        }
        toCloud() {
            let url = this.isPrivate ? `${this.urls.helpcenterUrl}/help/web/guide/89/311` : "https://www.edrawmax.cn/helpcenter/web/guide/89/311";
            window.open(url);
        }
        scrollAdding = false;
        scrollToAdd() {
            return;
            let con = <HTMLElement>this.$refs.filesScroll;
            if (this.scrollAdding) return;
            var scrollTop = con.scrollTop;
            if (con.scrollHeight - (scrollTop + con.offsetHeight) < 30) {
                if (this.activePageInfo.total <= this.activeList.length) return;
                this.scrollAdding = true;
                this.nextPage(this.activePageInfo.currentPage + 1);
            }
        }
        observe = null;
        addScroller() {
            if (this.observe) {
                this.observe.unobserve(this.$refs.scrollblock);
                this.observe = null;
            }
            let dom = this.$refs.scrollblock;
            if (dom) {
                this.observe = new (window as any).IntersectionObserver((e) => {
                    console.log(e);
                    if (
                        e[0] &&
                        e[0].isIntersecting &&
                        !this.scrollAdding &&
                        this.activePageInfo.total >= this.activeList.length &&
                        !this.searchMode
                    ) {
                        this.scrollAdding = true;
                        this.nextPage(this.activePageInfo.currentPage + 1);
                    }
                });
                this.observe.observe(dom);
            }
        }
        formatDate(str) {
            const addZero = (num) => {
                return (num < 10 && `0${num}`) || num;
            };
            let date = new Date(str);
            let Y = date.getFullYear();
            let M = date.getMonth() + 1;
            let D = date.getDate();
            let H = date.getHours();
            let Min = date.getMinutes();
            let sec = date.getSeconds();
            return `${Y}/${addZero(M)}/${addZero(D)} ${addZero(H)}:${addZero(Min)}:${addZero(sec)}`;
        }

        get layoutMode() {
            return this.$store.state.layoutMode;
        }
        set layoutMode(v) {
            this.$store.commit("setState", {
                type: "layoutMode",
                data: v,
            });
        }
        setLayout() {
            this.$store.commit("changeLayout");
        }
        orderName = "time";
        rotate = 0;
        clickOrder(name) {
            const change = this.orderName !== name;
            this.$bus.$emit("listHeadOrder", {
                sort: name,
                order: change ? this.rotate : this.rotate == 0 ? 180 : 0,
            });
        }
        setOrder(name) {
            this.orderName = name;
            if (name === "time") {
                if (this.rotate == 180) {
                    this.customTList = this.customTList.sort((a, b) => new Date(a.updated_at).getTime() - new Date(b.updated_at).getTime());
                } else {
                    this.customTList = this.customTList.sort((a, b) => new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime());
                }
            } else if (name === "name") {
                if (this.rotate == 0) {
                    this.customTList = this.customTList.sort((a, b) => naturalsort(a.name, b.name));
                } else {
                    this.customTList = this.customTList.sort((a, b) => naturalsort(b.name, a.name));
                }
            } else {
                this.orderName = "time";
                if (this.rotate == 180) {
                    this.customTList = this.customTList.sort((a, b) => new Date(a.updated_at).getTime() - new Date(b.updated_at).getTime());
                } else {
                    this.customTList = this.customTList.sort((a, b) => new Date(b.updated_at).getTime() - new Date(a.updated_at).getTime());
                }
            }
            localStorage.setItem("max_sort", this.orderName);
        }
        order() {
            if (this.rotate == 0) {
                this.rotate = 180;
                if (this.orderName == "name") {
                    this.customTList = this.customTList.sort((a, b) => naturalsort(b.name, a.name));
                } else if (this.orderName == "time") {
                    this.customTList = this.customTList.sort((a, b) => new Date(a.created_at).getTime() - new Date(b.created_at).getTime());
                }
            } else {
                this.rotate = 0;
                if (this.orderName == "name") {
                    this.customTList = this.customTList.sort((a, b) => naturalsort(a.name, b.name));
                } else if (this.orderName == "time") {
                    this.customTList = this.customTList.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
                }
            }
        }
        mounted() {
            this.initCustomData();
        }

        created() {}
        beforeDestroy() {
            this.observe?.unobserve(this.$refs.scrollblock);
            this.observe = null;
        }
    }
</script>
<i18n>
{
"zh": {
    "name": "文件名",
    "time": "时间",
    "deleteCustomT": "删除",
    "customNoData": "还没有创建个人模板哦~",
    "notFind": "没有找到相应文件",
    "customTocloud": "了解如何创建？"
},
"en": {
    "name": "Name",
    "time": "Time",
    "deleteCustomT": "Delete",
    "customNoData": "You haven't created your personal template.",
    "notFind": "Not Find",
    "customTocloud": "Learn how to create？"
},
"fr": {
    "name": "Nom",
    "time": "Temps",
    "deleteCustomT": "Effacer",
    "customNoData": "Vous n'avez pas créé votre modèle personnel. ",
    "notFind": "Aucun fichier correspondant trouvé",
    "customTocloud": "Apprenez à créer？"
},
"de": {
    "name": "Name",
    "time": "Zeit",
    "deleteCustomT": "Löschen",
    "customNoData": "Sie haben Ihre persönliche Vorlage noch nicht erstellt. Hier erfahren sie,",
    "notFind": "Keine entsprechende Datei gefunden",
    "customTocloud": "wie die erstellt wird？"
},
"jp": {
    "name": "名前",
    "time": "時間",
    "deleteCustomT": "削除",
    "customNoData": "個人用のテンプレートが作成されていません。",
    "notFind": "該当するファイルは見つかりませんでした",
    "customTocloud": "作成方法はこちら"
},
"es": {
    "name": "Nombre",
    "time": "Tiempo",
    "deleteCustomT": "Borrar",
    "customNoData": "No ha creado su plantilla personal. ",
    "notFind": "No encontrar",
    "customTocloud": "Aprenda a crear？"
},
"pt": {
    "name": "Nome",
    "time": "Hora",
    "deleteCustomT": "Eliminar",
    "customNoData": "Você não criou seu modelo pessoal. ",
    "notFind": "Não Encontrado",
    "customTocloud": "Aprenda como criar？"
},
"it": {
    "name": "Nome",
    "time": "Ora",
    "deleteCustomT": "Elimina",
    "customNoData": "Non hai creato il tuo modello personale. ",
    "notFind": "Nessun file corrispondente trovato",
    "customTocloud": "Impara a creare？"
},
"tw": {

    "name": "檔案名",
    "notFind": "沒有找到相應檔案",
    "time": "時間"
},
"kr": {
    "name": "파일 이름",
    "time": "시간",
    "deleteCustomT": "삭제하다",
    "customNoData": "아직 개인 템플릿을 만들지 않았네요~",
    "notFind": "해당 파일을 찾지 못했습니다",
    "customTocloud": "제작 방법을 알아볼까요?"
}
}
</i18n>
